import { UserMsg } from '../../models/user'

export const parseAllDbsResult = (results: any[], entityLabel: string): UserMsg => {
    const total = results.length
    const failed = results.filter((r: any) => !r.success)

    if (failed.length === 0)
        return { type: 'success', txt: `${entityLabel} created in all ${total} databases` }

    const mainFailed = failed.some((r: any) => r.company === 'auditech')
    if (mainFailed)
        return { type: 'danger', txt: `Failed to create ${entityLabel.toLowerCase()}` }

    const failedNames = failed.map((r: any) => r.company).join(', ')
    const succeeded = total - failed.length
    return {
        type: 'warning',
        txt: `${entityLabel} created in ${succeeded}/${total} databases. Failed: ${failedNames}`,
    }
}
